export type Coach = {
  name: string
  role: string
  avatar: string
}

/**
 * Fotos de coaches usadas en la fila de prueba del hero y en las reseñas.
 * Texto y fotos son de MUESTRA — reemplazar cada avatar y nombre por el del
 * comprador real antes de lanzar.
 */
export const coaches: Coach[] = [
  {
    name: 'Mike Dalton',
    role: 'Little League coach · Columbus, OH',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/423c7024-0d9b-4429-8b81-986bfea3aee1.jpg',
  },
  {
    name: 'Sara Boyd',
    role: 'Rec league coach · Atlanta, GA',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/cd64df10-6abd-4cd4-81b9-7cd69bd0c1a5.jpg',
  },
  {
    name: 'Dave Keller',
    role: 'Volunteer coach, 9-10u · Phoenix, AZ',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/e4a7beaf-3fc8-4d49-8a3e-685038e0a7e4.jpg',
  },
  {
    name: 'Ryan Whitfield',
    role: 'Travel-ball coach · Nashville, TN',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/d4c3cd3b-e513-4639-951c-5762d23b883a.jpg',
  },
  {
    name: 'Tom Nguyen',
    role: 'T-ball coach, first season · Sacramento, CA',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/4e3d0b7f-0670-47ca-816d-de0b9a2b1981.jpg',
  },
]
